/**
 * Standardised color scheme for solve statut
 * @type {{not_enough_objects: number[], success: number[], no_astrometry_match: number[], no_satellites: number[], no_satellites_no_astrometry_match: number[], not_enough_stars: number[], crash: number[]}}
 */
export const solve_colors = {
  success: [50, 205, 50], // green
  no_satellites: [120, 206, 240], // blue
  not_enough_stars: [235, 174, 89],
  no_astrometry_match: [235, 226, 103],
  no_satellites_no_astrometry_match: [240, 127, 166],
  not_enough_objects: [127, 240, 212],
  crash: [255, 99, 132],
}

/**
 * Random color generator for charts
 * @param numColors
 * @param alpha
 * @returns {*[]}
 */
export const generateChartColors = (numColors, alpha) => {
  const colors = []
  let r, g, b

  for (let i = 0; i < numColors; i++) {
    r = Math.floor(Math.random() * 256)
    g = Math.floor(Math.random() * 256)
    b = Math.floor(Math.random() * 256)

    colors.push("rgb(" + r + "," + g + "," + b + "," + alpha + ")")
  }

  if (numColors == 0) return colors
  const increment = Math.floor(255 / numColors)
  for (let i = 0; i < numColors; i++) {
    const r = increment * i
    const g = 255 - increment * i
    const b = 255 - increment * i
    colors.push(`rgba(${r}, ${g}, ${b}, ${alpha})`)
  }

  return colors
}
